import React, { Component } from 'react';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxAlarme extends Component {

    static defaultProps = {
        allowFreeform: true,
        label: "Alarme",
        placeholder: "Alarme",
    };

    render = () => {

        const fetchMethod = () => new Promise((resolve, reject) => {
            const alarmes = ["A relancer", "Offre de prêt"];
            resolve({ codeRetour: 0, reponseAPIobjet: alarmes });
        });

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            idValeurParDefaut="0"
            itemKey={item => item}
            itemText={item => item}
        />;

    };

};